import { useMantineTheme } from '@mantine/core';
import classNames from 'classnames/bind';
import { useTranslation } from 'locales';
import type { ReactNode } from 'react';
import type { FieldError } from 'react-hook-form';
import Switch from 'react-switch';
import { validationMessage } from 'shared/utils/validation';
import type { OnChangeEvent } from 'types/html-event';

import styleIdentifiers from './SwitchInput.module.scss';

const styles = classNames.bind(styleIdentifiers);

type SwitchInputProps = {
  label?: ReactNode;
  noMargin?: boolean;
  className?: string;
  onChange?: OnChangeEvent;
  value?: any;
  labelClassName?: string;
  error?: any;
  noShadow?: boolean;
};

export const SwitchInput = ({
  label,
  labelClassName,
  noMargin,
  className,
  onChange,
  error,
  value,
  noShadow,
  ...rest
}: SwitchInputProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <div className={styles('SwitchInput', className, noMargin && 'no-margin')}>
      <div className={styles('switch-wrapper')}>
        <div className={styles('label', labelClassName)}>{label}</div>
        <Switch
          onChange={onChange}
          {...rest}
          checked={value || false}
          handleDiameter={20}
          height={18}
          width={34}
          onColor={theme.colors.purple[6]}
          boxShadow={theme.shadows.xs}
          checkedIcon={false}
          className={styles('switch-input', !noShadow && 'shadow')}
          uncheckedIcon={false}
        />
      </div>
      {error && (
        <div className={styles('error-message')}>
          {t(
            validationMessage[(error as FieldError).type as keyof typeof validationMessage] ||
              (error as FieldError).message ||
              error,
          )}
        </div>
      )}
    </div>
  );
};
